module.exports = __webpack_public_path__ + "img/prize-xsd-light.833cd3d3.png";